import script from "./Batches.vue?vue&type=script&setup=true&lang=ts"
export * from "./Batches.vue?vue&type=script&setup=true&lang=ts"

import "./Batches.vue?vue&type=style&index=0&id=13fb7e6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13fb7e6e"]])

export default __exports__